import { subIdFor } from "./internal.js";
import { isSeriesRef, isSummaryRef } from "./watchRef.js";
const envelope = (a, b) => ({
    from: a.from < b.from ? a.from : b.from,
    to: a.to > b.to ? a.to : b.to,
});
/**
 * @internal Collapse a watcher's refs into the deduplicated subscription union the worker
 * receives: one entry per sub id, rows unioned across watchers (offsets for a curve, the
 * date envelope for a series), whole dominating. Called on every subscription change
 * inside `createArtis`.
 */
export const normalize = (refs) => {
    const groups = new Map();
    for (const ref of refs) {
        const subId = subIdFor(ref);
        const existing = groups.get(subId);
        if (isSummaryRef(ref)) {
            if (!existing)
                groups.set(subId, { kind: "summary", id: ref.id, ...(ref.spread ? { spread: ref.spread } : {}) });
            continue;
        }
        if (isSeriesRef(ref)) {
            if (!existing || existing.kind !== "series") {
                groups.set(subId, { kind: "series", id: ref.id, field: ref.field, dates: ref.dates ?? null });
                continue;
            }
            existing.dates = existing.dates && ref.dates ? envelope(existing.dates, ref.dates) : null;
            continue;
        }
        if (!existing || existing.kind !== "curve") {
            groups.set(subId, {
                kind: "curve",
                id: ref.id,
                field: ref.field,
                offsets: ref.offsets === undefined ? null : new Set(ref.offsets),
            });
            continue;
        }
        if (existing.offsets === null || ref.offsets === undefined) {
            existing.offsets = null;
            continue;
        }
        for (const offset of ref.offsets)
            existing.offsets.add(offset);
    }
    return Array.from(groups, ([subId, g]) => {
        if (g.kind === "summary")
            return { subId, kind: "summary", id: g.id, ...(g.spread ? { spread: g.spread } : {}) };
        if (g.kind === "series") {
            return { subId, kind: "series", id: g.id, field: g.field, ...(g.dates ? { dates: g.dates } : {}) };
        }
        return { subId, kind: "curve", id: g.id, field: g.field, offsets: g.offsets === null ? undefined : [...g.offsets] };
    });
};
//# sourceMappingURL=normalize.js.map